export interface GetReportAllModel {
  rcsa: any;
  led: any;
  kri: any;
}
export enum GetReportAllType {
  GetReportRCSA = "⌘➝Report➝RCSA➝GetReportRCSA",
  GetReportLED = "⌘➝Report➝LED➝GetReportLED",
  GetReportKRI = "⌘➝Report➝KRI➝GetReportKRI",
}
export type GetReportAllAction =
  | {
      data: {
        data: [];
      };
      type: GetReportAllType.GetReportRCSA;
    }
  | {
      data: {
        data: [];
      };
      type: GetReportAllType.GetReportLED;
    }
  | {
      data: {
        data: [];
      };
      type: GetReportAllType.GetReportKRI;
    };
